import "@assets/css/components/Cursos/style.css";

import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";

import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import { useContext } from "react";
import UserContext from "@context/User/UserContext";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import { Animated } from "react-animated-css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link as LinkScroll } from "react-scroll";
import Loader from "@helpers/loader/loader";
import { getCursosLicencia } from "@helpers/httpRequests/httpRequestsLicencias/httpRequestsLicencias";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { NotificationManager } from "react-notifications";

const ListadoCursosLecturaVeloz = ({ handleChangeComponent, showScrollButton, folioContrato, usuarioConConvenio, semanaAvance = 1, diagnosticoHabilitado }) => {
  const {
    contextValue: userContextValue,
    setContextValue: setUserContextValue,
  } = useContext(UserContext);

  const [cursos, setCursos] = useState([]);

  const [cursosLicencia, setCursosLicencia] = useState([]);

  //* States bandera para mostrar o no contenido

  const [showLoader, setShowLoader] = useState(true);

  const { usuarioLogeado } = userContextValue;

  const {correo} = usuarioLogeado;

  const cursosFiltrados = cursos.filter((curso) =>
    cursosLicencia.find(
      (cursoLicencia) => cursoLicencia.codigoCurso === curso.codigoCurso
    )
  );

  const cursosOrdenados = cursosFiltrados.sort((a, b) => {
    if (a.idCategoria < b.idCategoria) {
      return -1;
    }
  });

  const handleCursoSelection = (codigoCurso) => {

    if(codigoCurso === "LV23"){
      abrirCursoLectura();
      return;
    }

    const codigoSeccionSeleccionada = codigoCurso + "01";

    setUserContextValue({
      ...userContextValue,
      codigoCursoSeleccionado: codigoCurso,
      ultimoCursoTomado: codigoCurso,
      codigoSeccionSeleccionada,
    });

    handleChangeComponent(multiViewComponentsPaths.curso);
  };

  //*FUNCION PARA SELECCIONAR EL CURSO Y ASIGNARLO AL STATE

  const abrirCursoLectura = () => {
    if(diagnosticoHabilitado){
      return NotificationManager.warning('Tienes una evaluación diagnóstica pendiente, realizala primero.')
    }
    window.open(`https://virtual.globalclickmexico.com/lectura_2/initCurso.php?nombreUsuario=${correo}${usuarioConConvenio ? `&folioContrato=${folioContrato}&semanaAvance=${semanaAvance}` : ''}`);
  }

  useEffect(() => {
 
    const listarCursos = async () => {
      try {
        let { data } = await getCursos();

        if (!Array.isArray(data)) {
          data = [data];
        }

        setCursos(data);
      } catch (error) {
        console.log(error);
      }
    };

    const consultarCursosLicencia = async () => {
      try {
        const {
          data: { cursos },
        } = await getCursosLicencia(usuarioLogeado.idCredencial);


        setCursosLicencia(JSON.parse(cursos));

        setShowLoader(false);
      } catch (error) {
        console.log("Error al consultar los cursos de la licencia: ", error);
      }
    };

    listarCursos();

    consultarCursosLicencia();
  }, []);


  

  return (
    <>
      {showLoader ? (
        <Loader height={"80vh"} setShowLoader={setShowLoader} />
      ) : (
        <>
          {showScrollButton && (
            <Animated
              animationIn="fadeIn"
              isVisible={true}
              style={{ zIndex: "9999", position: "absolute" }}
            >
              <span
                className={`rounded-circle scrollTop text-center d-flex`}
                style={{
                  height: "50px",
                  width: "50px",
                  fontSize: "2rem",
                  backgroundColor: "#F59E0B",
                  position: "fixed",
                  bottom: "70px",
                  right: "70px",
                }}
              >
                <LinkScroll
                  className="pointer"
                  activeClass="active"
                  to="scrollTopElement"
                  spy={true}
                  smooth={true}
                  duration={800}
                  containerId="scrollTop"
                  style={{ color: "black", width: "100%" }}
                >
                  <FontAwesomeIcon icon={faArrowUp} />
                </LinkScroll>
              </span>
            </Animated>
          )}

          {/* //*COMPONENTE ScrollToTop */}
          <Animated
            animationIn="fadeIn"
            animationInDuration={2000}
            animationOut="fadeOut"
            isVisible={true}
          >
            <Container fluid className="p-0 mb-5 mt-5">
              {/* <Row>
                <Col>
                  <Row className="mb-3 justify-content-between">
                    <Col className="text-capitalize col-auto">
                        <TitleDashboard title="Tus cursos" />
                    </Col>
                  </Row>
                </Col>
              </Row> */}


              {/* Vista de los cursos por categoria */}
                <Row className="justify-content-center mt-4">
                  {cursosOrdenados.map(
                    (curso, idx) =>
                      curso.estatus === 1 && (
                        <Col
                          id={idx}
                          className="pointer col-9 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                          onClick={() => {
                             handleCursoSelection(curso.codigoCurso);
                          }}
                        >
                          <Card className=" mb-4 card-predefinidas border-0">
                            <picture width="100%" height="100%">
                              <source
                                srcSet={`${require(`@assets/images/portadas/${curso.portadaCurso}`)}`}
                              />
                              <img
                                loading="lazy"
                                className="img-fluid"
                                src={`${require(`@assets/images/portadas/${curso.portadaCurso}`)}`} // Aquí va la URL de la imagen de fondo
                                alt="Imagen de fondo"
                              />
                            </picture>
                          </Card>
                        </Col>
                      )
                  )}
                </Row>
            </Container>
          </Animated>
        </>
      )}
    </>
  );
};

export default ListadoCursosLecturaVeloz;
